import { Checkbox, CheckboxTypes, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Flex } from 'native-base';
import React from 'react';

import { SelectOptionsProps } from '../..';
import { SelectableItem } from '../../../components/SelectableItem';

interface SectionProps {
  fieldName: string;
  title: string;
  options: CheckboxTypes.Option[];
  sideOptions?: CheckboxTypes.Option[];
  onChange: (value: SelectOptionsProps) => void;
  selectedValues: string[];
  isSingle?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  title,
  options,
  sideOptions,
  fieldName,
  onChange,
  selectedValues,
  isSingle = false,
}) => {
  const sectionItems = useBreakpointValue({
    base: (
      <Flex style={{ gap: 8 }} direction="row" flexWrap="wrap">
        {[...options, ...(sideOptions || [])].map((option) => (
          <SelectableItem
            key={option.value}
            isSelected={selectedValues.includes(option.value)}
            label={option.label}
            onPress={() => onChange({ value: { [fieldName]: [option.value] }, isSingle })}
          />
        ))}
      </Flex>
    ),
    lg: (
      <HStack space={Spacing['inline.nano']}>
        <Checkbox
          onChange={(value) => onChange({ value: { [fieldName]: [value] }, isSingle })}
          testId="primary-checkbox"
          options={options}
          vertical
          selectedValues={selectedValues}
        />

        {sideOptions && (
          <Checkbox
            onChange={(value) => onChange({ value: { [fieldName]: [value] }, isSingle })}
            testId="secondary-checkbox"
            options={sideOptions}
            vertical
            selectedValues={selectedValues}
          />
        )}
      </HStack>
    ),
  });

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} lineHeight="distant">
        {title}
      </Text>
      {sectionItems}
    </VStack>
  );
};
